'use client';

import { cn } from '@workspace/lib';
import { useProductType } from './useProductType';
import { ProductTypeProps } from './product-type.types';
import { ProductTypeHeader } from './ui/ProductTypeHeader';
import { ProductTypeGrid } from './ui/ProductTypeGrid';

export function ProductType({ className = '', block }: ProductTypeProps) {
  const {
    resolvedTitleText,
    buttons,
    alignmentClass,
    displayProducts,
    backgroundClass,
    getButtonUrl,
    getOpenInNewTab,
  } = useProductType(block);

  if (!block || typeof block !== 'object') return null;

  return (
    <div className={cn('background-container', backgroundClass)}>
      <div className={`py-12 md:py-4xl px-6 md:px-4xl porta-container ${className}`}>
        <div>
          <ProductTypeHeader
            title={resolvedTitleText}
            alignmentClass={alignmentClass}
            buttons={buttons}
            getButtonUrl={getButtonUrl}
            getOpenInNewTab={getOpenInNewTab}
          />
          <ProductTypeGrid products={displayProducts} />
        </div>
      </div>
    </div>
  );
}
